import React, { useEffect, useState, useCallback, useMemo } from 'react';
import ReactDom from 'react-dom';
import { Link, useHistory, useParams } from 'react-router-dom';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
} from 'reactstrap';
import {
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
} from 'reactstrap';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ParticipantForm, {
  LegalParticipantSchema,
  IndividualParticipantSchema,
  ParticipantSchema,
} from './ParticipantForm';
import {
  createContract,
  saveContract,
  sendContract,
} from '../api/actions/contracts';
import { updateTemplate } from '../api/actions/templates';
import { fetcher } from '../api/client';
import { faEdit, faUser } from '@fortawesome/free-regular-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import LoadingButton from './LoadingButton';
import ConfirmationModal from './ConfirmationModal';
import NoContractsModal from './NoContractsModal';
import { PDFIndex } from '../pages/PdfViewer';
import { useTranslation } from 'react-i18next';
import { useProfile } from '../api/hooks/profile';
import { unmaskPhone, truncate } from '../utils';
import { toast } from 'react-toastify';
import Checkbox from './Checkbox';
import { languages } from '../config';
import i18n from '../i18n';
import CustomTextEditor from './Editor/Editor';
import { mongoObjectId } from '../utils';
import { useStripe } from '@stripe/react-stripe-js';
import config from '../config';
import { getDisplayName } from '../utils';
import InputWithLoader from './InputWithLoader';
import { useAuthState } from '../context/auth';
import FileSendIcon from '../images/pdf/file-send.svg';

import createPersistedState from 'use-persisted-state';

import {
  useEditor,
  useEditorActions,
  FILL_MY_DATA,
  RESET_FILL_MY_DATA,
  SET_LANGUAGE,
  SET_SHIELD_TYPE,
  RESET_DOCUMENT,
  SET_PARTICIPANTS,
  SET_NUM_PAGES,
  SET_CURRENT_PAGE,
  SET_DOCUMENT,
  CHANGED_DATA,
  RESTORE_ITEM,
  SET_LAWYER_NEEDED,
  ADD_TO_CART,
  SET_IS_INVOICE_NEEDED,
  SET_CHECKOUT_INFO,
  SET_EDIT_FIELD,
} from '../context/editor';

import { useUserLanguage } from '../hooks/useLanguages';

const useAccountVerificationState = createPersistedState('accountVerified');

// const ContractSchema = Yup.object().shape({
//     language: Yup.string(),
//     shield: Yup.string(),
//     fillMyData: Yup.string(),
//     participants: Yup.array().of(ParticipantSchema)
//   })

//const createTemplate = ({templateId, ...values}) => {

const createTemplate = ({ templateId, document, tenantId }) => {
  let url = `/templates/${templateId}/buy`;

  return {
    method: 'POST',
    endpoint: url,
    prefix: ' ',
    headers: {
      'Content-Type': 'application/json',
    },
    body: { ...document, tenantId },
  };
};

const buttoner = {
  borderRadius: '50%',
  color: '#6F767D',
  backgroundColor: 'white',
  font: 'normal normal normal 10px/14px Lato',
  border: '1px solid #D5D5D5',
  display: 'inline-block',
  lineHeight: '30px',
  marginRight: '7px',
  marginBottom: '7px',
  textAlign: 'center',
  width: '30px',
};

const buttonerActive = {
  borderRadius: '50%',
  color: '#FFFFFF',
  backgroundColor: '#F47B33',
  font: 'normal normal normal 10px/14px Lato',
  border: '1px solid #F47B33',
  display: 'inline-block',
  lineHeight: '30px',
  marginRight: '7px',
  marginBottom: '7px',
  textAlign: 'center',
  width: '30px',
};

const myBtn = {
  position: 'relative',
  display: 'inline-block',
};

const faCheck = {
  position: 'absolute',
  top: '0px',
  right: '7px',
  borderRadius: '50%',
  color: 'white',
  backgroundColor: '#07BF39',
  font: 'normal normal normal 8px/11px Lato',
  border: '1px solid #07BF39',
  display: 'inline-block',
  textAlign: 'center',
  width: '10px',
  height: '10px',
};

const pFont = {
  font: 'normal normal bold 16px/20px Lato',
};

const AccountVerifyModal = (props) => {
  const { isOpen } = props;
  const { t } = useTranslation('common');
  return (
    <Modal isOpen={isOpen} centered>
      <ModalHeader className="text-center">
        {t('successMessages.verifyAccount')}
      </ModalHeader>
      <ModalBody className="text-center">
        <span className="text-center text-muted mb-4 text-center">
          {t('successMessages.verifyAccountLink')}
        </span>
        <img
          className="m-1 mb-2 p-1"
          src={FileSendIcon}
          style={{ width: 120 }}
        />
        <br />
        <span className="font-italic text-center text-muted mb-4 text-center">
          {t('successMessages.waitingVerifyAccount')}
        </span>
      </ModalBody>
    </Modal>
  );
};

function ContractConfiguration({
  className,
  onClose,
  formik: {
    handleChange,
    handleSubmit,
    isSubmitting: isSending,
    values,
    errors,
    touched,
  },
  onFillMyData,
  fillMyData,
  saving,
  documentId,
  tabs,
  currentTab,
  header,
  footer,
  FooterComponent,
  onRequestAgreement,
  languages,
  currentLanguage,
  onLanguageChange,
  shields,
  onShieldChange,
  shieldType,
  isPdf,
  isDynamic,
  onAddParticipant,
  numPagesArr,
  pdfUrl,
  onPDFPageClick,
  goToPage,
  isEditable,
  onDocumentLoadSuccess,
  onRemoveParticipant,
  onAddParticipantSignature,
  isOpen,
  setIsOpen,
  submitInterceptor,
}) {
  const { t } = useTranslation('common');
  const [truncated, setTruncated] = useState(true);

  // const {name, ...participantErrors} = errors;
  // const {name, ...participantTouched} = touched;
  // const contractErrors = {
  //     name
  // }
  // if (!isOpen || !contract) {
  //     return null;
  // }

  const [innerCurrentTab, setInnerCurrentTab] = useState(currentTab);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [buttonLegend, setButtonLegend] = useState();

  const [editorState, editorDispatch] = useEditor();
  const [currentEditableItem, setCurrentEditableItem] = useState(true);
  const [isCheckout, setCheckout] = useState(1);
  const [isMoral, setIsMoral] = useState(false);
  const { register, watch, errors: errorRQ } = useForm({ mode: 'onBlur' });
  const { setCurrentElement } = useEditorActions();
  const [stripePaymentId, setStripePaymentId] = useState();
  const { profile, can } = useProfile();
  const stripe = useStripe();
  const auth = useAuthState();
  const { publicTemplateId, templateId } = useParams();
  const editionPrice = can('EDIT_TEMPLATE') ? 0 : 25;

  const handlePurchase = async (result) => {
    let itemsT = [];
    let newDocumentId = publicTemplateId ? 'public-template' : 'template';

    if (
      !can('EDIT_TEMPLATE') &&
      editorState?.carrito.filter((x) => x._id !== -1).length > 0
    )
      itemsT.push({
        sku: 'edit_element_mx',
        quantity: editorState?.carrito.filter((x) => x._id !== -1).length,
      });
    if (editorState?.carrito.filter((x) => x._id === -1).length > 0)
      itemsT.push({
        sku: 'lawyer_approval_mx',
        quantity: editorState?.carrito.filter((x) => x._id === -1).length,
      });
    if (
      editorState?.mode === 'public-template' &&
      editorState?.publicTemplate?.stripeId &&
      editorState?.publicTemplate?.stripeInfo?.id &&
      !editorState?.publicTemplate?.userTemplate?._id
    )
      itemsT.push({
        price: editorState?.publicTemplate?.stripeInfo?.id,
        quantity: 1,
      });

    await stripe.redirectToCheckout({
      successUrl: `${config.baseUrl}/checkout/success?productName=Edicion De Plantilla`,
      //cancelUrl: `${config.baseUrl}/documents/${editorState?.documentId}/edit`,
      cancelUrl: `${config.baseUrl}/${newDocumentId}s/${editorState.documentId}/edit`,

      mode: 'payment',
      lineItems: [...itemsT],
      clientReferenceId: `template-${result}`,
      customerEmail: profile.email,
    });
  };

  const { mutate: mutateRecover } = useMutation(
    (payload) => fetcher(createTemplate(payload)),
    {
      onSuccess: (result) => {
        handlePurchase(result.templateId);
      },
    }
  );

  const { mutate: saveTemplateMutate } = useMutation(
    (payload) => fetcher(updateTemplate(payload)),
    {
      onSuccess: (result) => {
        toast.success('Se ha guardado con exito');
      },
    }
  );

  const changeTab = (tabId) => () => {
    setInnerCurrentTab(tabId);
  };

  const unTruncate = () => {
    setTruncated((isTruncated) => !isTruncated);
  };

  const editMode = () => {
    setCurrentEditableItem(true);
  };

  const cancelEdit = () => {
    setCurrentEditableItem(false);
  };

  const selectNewItem = (id) => {
    setCurrentElement(id);
    setCurrentEditableItem(false);
  };

  useEffect(() => {
    setInnerCurrentTab(currentTab);
  }, [currentTab]);

  const toggleIsInvoice = () => {
    editorDispatch({
      type: SET_IS_INVOICE_NEEDED,
      data: { isInvoiceNeeded: !editorState?.checkoutInfo?.isInvoiceNeeded },
    });
  };

  const toggleIsLawyer = () => {
    if (!editorState?.checkoutInfo?.isLawyerNeeded) {
      editorDispatch({
        type: ADD_TO_CART,
        data: {
          producto: 'Revisión de abogado',
          importe: 250,
          _id: -1,
          index: -1,
        },
      });
    } else if (editorState?.checkoutInfo?.isLawyerNeeded) {
      deleteItem(-1, -1);
    }
    editorDispatch({
      type: SET_LAWYER_NEEDED,
      data: { isLawyerNeeded: !editorState?.checkoutInfo?.isLawyerNeeded },
    });
  };

  const deleteItem = (id, index) => {
    setCurrentEditableItem(false);
    toast.error(t('templateEdition.deleteModal'), {
      position: 'top-right',
    });
    setCurrentElement({});
    editorDispatch({ type: RESTORE_ITEM, data: { id, index } });
  };

  const handleCheckout = () => {
    if (currentEditableItem)
      toast.error(t('templateEdition.noSavedChanges'), {
        position: 'top-right',
      });
    else {
      setCheckout(2);
      setCurrentEditableItem(false);
      setCurrentElement({});
    }
  };

  const handleSaveTemplate = () => {
    saveTemplateMutate({
      templateId: editorState.document._id || editorState.document.templateId,
      elements: editorState.document.elements,
    });
  };

  const onSignUpSuccess = () => {
    setIsOpen(true);
  };

  const handleConfirm = () => {
    if (!auth.hasAccount)
      auth.openAuthModal({ type: 'signup', onSignUpSuccess });
    else setIsConfirmationOpen(true);
  };

  const Question = ({ question, participants, setButtonLegend }) => {
    const participantsAreVoid = Object.values(participants).every(
      (i) => i.name === ''
    );

    participantsAreVoid
      ? setButtonLegend('Pagar')
      : setButtonLegend('Pagar y enviar');

    const Text = ({ children }) => (
      <span className="text-accent">{children}</span>
    );
    return (
      <span className="px-2">
        {question}
        <br></br>
        {participantsAreVoid ? (
          <> {t('actions.sendWithouthParticipants')} </>
        ) : (
          <>
            <span>{t('actions.sendWithParticipants')} </span>
            <br></br>
            {participants.map((participant, i) => (
              <React.Fragment key={participant._id}>
                {i === participants.length - 1 &&
                  participants.length > 1 &&
                  participant.name !== '' &&
                  ` ${t('and')} `}
                {i === 0 && ''}
                {i > 0 &&
                  i < participants.length - 1 &&
                  participant.name !== '' &&
                  ',  '}
                <Text key={participant._id}>
                  {participant.obligation === 'individual'
                    ? getDisplayName(participant.name, participant.last_name)
                    : getDisplayName(participant.name)}
                </Text>
              </React.Fragment>
            ))}
          </>
        )}
        <br />
        <br />
        <span style={{ font: 'normal normal normal 12px/12px Lato' }}>
          {t('actions.useTemplateMessage')}
        </span>
      </span>
    );
  };

  const handlePayment = () => {
    const email = watch('email');
    const rfc = watch('rfc');

    editorDispatch({
      type: SET_CHECKOUT_INFO,
      data: {
        isLawyerNeeded: editorState?.checkoutInfo?.isLawyerNeeded,
        invoiceRFC: rfc,
        invoiceEmail: email,
        isInvoiceNeeded: editorState?.checkoutInfo?.isInvoiceNeeded,
        isMoral: isMoral,
        paymentTotal: editorState?.carrito
          .map((x) => x?.importe)
          .reduce((acc, score) => acc + score, 0),
      },
    });

    if (!auth.hasAccount) {
      return auth.openAuthModal({ type: 'signup' });
    } else {
      mutateRecover({
        templateId: documentId,
        document: editorState?.document,
        tenantId: profile.organization,
      });
    }
  };

  //console.log(editorState);

  const handleChangeClauses =
    ({ value }) =>
    () => {
      let price = value[0].type === 'title' ? 0 : editionPrice;
      let textAlign;
      editorDispatch({
        type: SET_EDIT_FIELD,
        data: false,
      });
      if (
        value[0].type === 'align_right' ||
        value[0].type === 'align_center' ||
        value[0].type === 'align_left' ||
        value[0].type === 'align_justify'
      ) {
        textAlign = value[0].type.replace('align_', '');
        editorDispatch({
          type: CHANGED_DATA,
          data: {
            children: value[0].children[0].children,
            _id: value[0].children[0]._id,
            isModified: true,
            type: value[0].children[0].type,
            price: price,
            textAlign: textAlign,
          },
        });
      } else
        editorDispatch({
          type: CHANGED_DATA,
          data: {
            children: value[0].children,
            _id: value[0]._id,
            isModified: true,
            type: value[0].type,
            price: price,
            textAlign: value[0].textAlign,
          },
        });
      setCurrentEditableItem(false);
      setCurrentElement({});
      var parentDiv = document.getElementById('originalEditoContainer');
      var childEditor = document.getElementById('editor--to--insert');
      parentDiv.appendChild(childEditor);
    };
  useEffect(() => {
    if (!editorState.editorField) {
      setCurrentEditableItem(false);
    }
  }, [editorState.editorField]);
  useEffect(() => {
    setCurrentEditableItem(true);
  }, [currentEditableItem]);

  return (
    <div>
      <div
        className={clsx(
          'general-configuration px-4 h-100 mt-5',
          isPdf && 'mt-2'
        )}
      >
        {editorState?.currentElement?._id && currentEditableItem && (
          <CustomTextEditor
            textAlign={editorState?.currentElement?.textAlign || 'left'}
            contract={editorState.document}
            key={editorState?.currentElement?._id}
            children={[editorState?.currentElement]}
            isReadOnly={false}
            onChangeClause={handleChangeClauses}
            onCancelEdit={cancelEdit}
          />
        )}
      </div>
    </div>
  );
}

function getInitialValues(template) {
  if (!template.participants) return {};

  return {
    name: template.name,
    participants: template.participants.reduce((obj, participant) => {
      if (participant?._id) {
        obj[participant._id] = {
          name: '',
          last_name: '',
          email: '',
          label: '',
          phone: '',
          representative: '',
          requestAgreement: false,
          ...participant,
        };
      }

      return obj;
    }, {}),
  };
}

function getInitialTouched(template) {
  if (!template.participants) return {};

  return {
    name: false,
    participants: template.participants.reduce((obj, participant) => {
      obj[participant._id] = {
        name: false,
        last_name: false,
        email: false,
        label: false,
        phone: false,
        representative: false,
      };

      return obj;
    }, {}),
  };
}

const getParticipantsSchema = (participants) => {
  let schema = {};

  if (participants) {
    schema = participants.reduce((obj, participant) => {
      obj[participant._id] = ParticipantSchema;

      return obj;
    }, {});
  }

  return Yup.object().shape(schema);
};

function getContractSchema(contract) {
  return Yup.object().shape({
    name: Yup.string(),
    participants: getParticipantsSchema(contract.participants),
  });
}

function ContractConfigurationContainer({
  className,
  isPdf,
  isDynamic,
  tabs = true,
  currentTab = 1,
  header = true,
  footer = true,
  documentId,
  onReturn,
  onContractSent = () => {},
  FooterComponent,
}) {
  const { t } = useTranslation('common');
  const errorSentResponseId = 'error-sending-document';
  // router hooks
  const history = useHistory();
  const { templateId } = useParams();
  const id = templateId || documentId;
  const queryClient = useQueryClient();

  // Context
  const { profile } = useProfile();
  const [editorState, editorDispatch] = useEditor();
  // Memoization
  const shieldList = useMemo(() => {
    return Array.from(Array(2).keys()).map((number) => ({
      value: `shield${number + 1}`,
      label: t(`shield`, { context: 'number', number: number + 1 }),
    }));
  }, [t]);
  const [userLanguage, languageList] = useUserLanguage();
  const [initialValues, ContractSchema] = useMemo(() => {
    return [
      getInitialValues(editorState?.document),
      getContractSchema(editorState?.document),
    ];
  }, [editorState.document]);

  const { mutate: sendContractMutate } = useMutation(
    (payload) => fetcher(sendContract(payload)),
    {
      onSuccess: () => {
        editorDispatch({ type: RESET_DOCUMENT });
        // if (templateId) {
        //     templatesDispatch({ type: INCREMENT_SENT_CONTRACTS, templateId })
        // }
        queryClient.invalidateQueries('profile');

        setHasSucceed(true);
        setIsLoading(false);
        setSubmitting(false);
        if (onContractSent) {
          onContractSent();
        } else if (documentId) {
          history.push('/documents');
          toast.info(t('successMessages.documentCreated'));
        } else {
          setTimeout(() => {
            handleCancel();
          }, 1000);
        }
      },
      onError: (error) => {
        setHasSucceed(false);
        setIsLoading(false);
        history.replace(`/documents/${editorState.document._id}/edit`);
        toast.error(
          t(`errors.${error.message}`, t('errorMessages.sendingContract')),
          {
            toastId: errorSentResponseId,
          }
        );
      },
      onSettled: () => {
        setIsLoading(false);
      },
    }
  );

  const { mutate: saveContractMutate } = useMutation(
    (payload) => fetcher(saveContract(payload)),
    {
      onSuccess: (result) => {
        editorDispatch({ type: SET_DOCUMENT, document: result.data });
        sendContractMutate({
          _id: result.data._id,
        });
      },
      onError: () => {
        setIsLoading(false);
      },
    }
  );

  // State
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [accountVerified, setAccountVerified] = useAccountVerificationState({
    verified: false,
  });
  //const [accountVerified, setAccountVerified] = useAccountVerificationState();
  const [currentLanguage, setCurrentLanguage] = useState(
    userLanguage ?? languageList?.[0]
  );
  // const [isNoContractsOpen, setIsNoContractsOpen] = useState(false)
  const [hasSucceed, setHasSucceed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fillMyData, setFillMyData] = useState('');
  const { checkMissingSignatures, checkCredits, checkSignatureCredits } =
    useEditorActions();
  const [newCurrentTab, setNewCurrentTab] = useState(currentTab);
  currentTab = newCurrentTab;
  const auth = useAuthState();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (accountVerified.verified) {
      setIsOpen(false);
      setAccountVerified({ verified: false });
      auth.openAuthModal({ type: 'login' });
    }
  }, [auth, setAccountVerified, accountVerified]);

  const onSignUpSuccess = () => {
    setIsOpen(true);
  };

  const submitInterceptor = () => {
    if (!auth.hasAccount) {
      auth.openAuthModal({ type: 'signup', onSignUpSuccess });
      setIsLoading(false);
    } else formik.handleSubmit();
  };

  const formik = useFormik({
    initialValues,
    onSubmit: (values, actions) => {
      let hasRequestAgreement = false;

      if (editorState.shieldType.value === 'shield3') {
        const participants = Object.values(values.participants);
        hasRequestAgreement = participants?.some?.((p) => p.requestAgreement);

        if (!hasRequestAgreement) {
          return toast.error(t('errors.MissingRequestAgreement'), {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }

      const hasNoCredits = checkCredits();
      const hasNoSignatureCredits = checkSignatureCredits();
      const isMissingSignatures = checkMissingSignatures();

      if (isMissingSignatures || hasNoSignatureCredits || hasNoCredits)
        return actions.setSubmitting(false);

      setHasSucceed(false);
      setIsConfirmationOpen(true);
    },
    validationSchema: ContractSchema,
    enableReinitialize: true,
  });

  useEffect(() => {
    editorDispatch({ type: SET_SHIELD_TYPE, shieldType: shieldList[0] });
  }, [shieldList, editorDispatch]);

  useEffect(() => {
    editorDispatch({
      type: SET_LANGUAGE,
      language: userLanguage ?? languageList?.[0],
    });
  }, [languageList, userLanguage, editorDispatch]);

  // useEffect(() => {

  //     if (modalsState.reset) {
  //         setFillMyData('')
  //         formik.setValues(getInitialValues(editorState.document));
  //         formik.setTouched(getInitialTouched(editorState.document));
  //         dispatch({ type: UNRESET })
  //     }
  // }, [formik, dispatch, modalsState.reset, editorState.document])

  const handleFillMyData =
    ({ name, checked }) =>
    () => {
      if (!checked) {
        editorDispatch({ type: FILL_MY_DATA, profile, name });
      } else {
        editorDispatch({ type: RESET_FILL_MY_DATA });
      }
    };

  const handleSendContract = async (values) => {
    const hasShield2Credits =
      profile?.nom151?.remaining > 0 &&
      editorState.shieldType.value === 'shield2';
    const hasShield3Credits =
      profile?.shield3?.remaining > 0 &&
      editorState.shieldType.value === 'shield3';

    const stampNom = hasShield2Credits || hasShield3Credits;

    const newContract = {
      ...editorState.document,
      participants: Object.values(formik.values.participants).map(
        (participant) => ({
          ...participant,
          phone: unmaskPhone(participant.phone),
          last_name:
            participant.obligation === 'individual'
              ? participant.last_name
              : undefined,
          signatures: editorState.isPdf
            ? editorState.signatures[participant._id]
            : [],
        })
      ),
      language: editorState.language.value?.toUpperCase?.(),
      jurisdiction: editorState.jurisdiction,
      signatureType: editorState.signatureType,
      shield3ValidationRequired: true,
      stampNom,
      templateId,
      shield: editorState.shieldType.value,
    };
    setIsLoading(true);
    // alert(JSON.stringify(values, null, 2));
    // await db.table('contracts').put({ id: modalsState.templateId, ...newContract })

    // guardamos contrato
    saveContractMutate(newContract);
  };

  useEffect(() => {
    editorDispatch({
      type: SET_PARTICIPANTS,
      participants: Object.values(formik.values?.participants ?? {}),
    });
  }, [formik.values, editorDispatch]);

  // console.log({modalsState});
  const setSubmitting = useCallback(formik.setSubmitting, [
    formik.setSubmitting,
  ]);

  const handleCancel = useCallback(() => {
    setIsConfirmationOpen(false);
    setHasSucceed(false);
    setSubmitting(false);
    setNewCurrentTab(3);
  }, [setSubmitting]);

  const handleClose = useCallback(() => {
    // history.push('/')
    history.goBack();
  }, [history]);

  useEffect(() => {
    if (profile?.nom151?.remaining > 0) {
      editorDispatch({
        type: SET_SHIELD_TYPE,
        shieldType: shieldList.find((shield) => shield.value === 'shield2'),
      });
    }
  }, [profile, shieldList, editorDispatch]);

  function handleLanguageChange(option) {
    editorDispatch({ type: SET_LANGUAGE, language: option });
  }

  function handleShieldChange(option) {
    editorDispatch({ type: SET_SHIELD_TYPE, shieldType: option });
  }

  const handleRequestAgreement = (fieldName, checked) => () => {
    formik.setFieldValue(fieldName, !checked);
  };

  const handleDocumentLoadSuccess = ({ numPages }) => {
    editorDispatch({ type: SET_NUM_PAGES, numPages });
  };

  const handlePDFPageClick = ({ pageNumber }) => {
    editorDispatch({ type: SET_CURRENT_PAGE, pageNumber });
  };

  const goToPage = (pageNumber) => () => {
    editorDispatch({ type: SET_CURRENT_PAGE, pageNumber });
  };

  const handleAddParticipant = () => {
    editorDispatch({ type: 'add-participant' });
  };

  const handleRemoveParticipant = (participantId) => () => {
    editorDispatch({ type: 'remove-participant', participantId });
  };

  const handleAddParticipantSignature = (participantId) => () => {
    editorDispatch({ type: 'add-signature', participantId });
  };

  return (
    <React.Fragment key={id}>
      <ContractConfiguration
        templateId={documentId}
        className={className}
        saving={false}
        formik={formik}
        tabs={tabs}
        header={header}
        footer={footer}
        FooterComponent={FooterComponent}
        currentTab={currentTab}
        onClose={onReturn ?? handleClose}
        onFillMyData={handleFillMyData}
        fillMyData={editorState.fillMyData}
        currentJurisdiction={editorState.jurisdiction}
        currentSignatureType={editorState.signatureType}
        disableStampNom={profile.nom151 && profile.nom151.remaining <= 0}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onLanguageChange={handleLanguageChange}
        currentLanguage={editorState.language}
        languages={languageList}
        shields={shieldList}
        shieldType={editorState.shieldType}
        onShieldChange={handleShieldChange}
        isPdf={editorState.isPdf}
        isDynamic={editorState.isDynamic}
        isEditable={true}
        onRequestAgreement={handleRequestAgreement}
        numPagesArr={editorState.numPagesArr ?? []}
        pdfUrl={editorState.document?.importedPdf}
        onPDFPageClick={handlePDFPageClick}
        goToPage={goToPage}
        onDocumentLoadSuccess={handleDocumentLoadSuccess}
        onAddParticipant={handleAddParticipant}
        onRemoveParticipant={handleRemoveParticipant}
        onAddParticipantSignature={handleAddParticipantSignature}
        submitInterceptor={submitInterceptor}
      />
      <ConfirmationModal
        isOpen={isConfirmationOpen}
        hasSucceed={hasSucceed}
        isLoading={isLoading}
        onConfirm={handleSendContract}
        confirmText={t('actions.send')}
        cancelText={t('Personalizar elementos')}
        question={t('sendDocumentQuestion')}
        onCancel={handleCancel}
        participants={editorState.participants}
      />

      <AccountVerifyModal isOpen={isOpen} />
    </React.Fragment>
  );
}

export default ContractConfigurationContainer;
